import { render, staticRenderFns } from "./editPromoEndDate.vue?vue&type=template&id=c525c4ea&lang=pug"
import script from "./editPromoEndDate.vue?vue&type=script&lang=js"
export * from "./editPromoEndDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports